import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=38a2d608&scoped=true&"
import script from "./Work.vue?vue&type=script&lang=js&"
export * from "./Work.vue?vue&type=script&lang=js&"
import style0 from "./Work.vue?vue&type=style&index=0&id=38a2d608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a2d608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a2d608')) {
      api.createRecord('38a2d608', component.options)
    } else {
      api.reload('38a2d608', component.options)
    }
    module.hot.accept("./Work.vue?vue&type=template&id=38a2d608&scoped=true&", function () {
      api.rerender('38a2d608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/timesheet/Work.vue"
export default component.exports